import React from 'react';
import { useEffect, useState, useRef } from 'react';
import useNotifications from "../hooks/useNotifications";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { userManualDownloadUrl, visitorRegistrationLink, disclaimer, link_BASE_URL } from '../utils/constants';
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import NotificationMeta from "./NotificationMeta";
import StepHeader from '../screens/registration/stepHeader'
import ExhibitorTopMenu from "../common_components/exhibitor_module_topmenu";
import { readSessionList } from "./HeaderInfoTiles";
import MobileInfoPanel from "./MobileInfoPanel";


// Modal.setAppElement("#root");


// {head,subHeader}
const VisitorHeader2 = () => {
    const navigate = useNavigate();

    // const history = useNavigate();
    const [isLoading, setLoader] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
    const marqueeRef = useRef(null);
    const notificationRef = useRef(null);

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js',
        //   'js/azia.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }

    // useEffect(() => {
    //     loadScripts();
    //     // console.log("sessionStorage.getItem(sessionExhibitorDrawerData)------->", sessionStorage.getItem(sessionExhibitorDrawerData))

    // }, []);


    const openPdf = () => {
        var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
        window.open(URL, null);
    }

    const address = sessionStorage.getItem('ExhibitionAddressSS')

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onLogoutClick = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    };

    const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";

    const profileRef = useRef(null);
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");

    useEffect(() => {
        function handleClickOutside(event) {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfile(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const visitorRegistrationLinkHeader = `${link_BASE_URL}visitorregistration/${sessionStorage.getItem("exhibitionCode")}`

    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <>

                {isMobileMenuOpen && (
                    <div
                        className="mobile-menu-overlay exhibitor-mobile-overlay"
                        onClick={closeMobileMenu}
                    ></div>
                )}


                <div
                    className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
                        }`}
                >
                    {/* Welcome + user name (same as the desktop sidebar), exhibition details and
                        assistance contacts - office landline first, then the mobile numbers */}
                    {(() => {
                        const drawer = readSessionList('sessionVisitorDrawerData')[0] || {}
                        const landline = drawer.Phone ? String(drawer.Phone).replace(/^\s*phone\s*:\s*/i, '').trim() : ''
                        const phones = [landline, ...readSessionList('sessionExhibitionMobileNo')]
                            .filter((p, i, all) => p && all.indexOf(p) === i)
                        const userName = sessionStorage.getItem("drawerName")
                        return (
                            <MobileInfoPanel
                                name={userName || sessionStorage.getItem("sessionExhibitionName") || "India ITME 2026"}
                                welcome={userName ? 'Welcome,' : ''}
                                onClose={closeMobileMenu}
                                details={{
                                    dates: `${sessionStorage.getItem("ExhibitionFromDateSS") || ''} - ${sessionStorage.getItem("ExhibitionToDateSS") || ''}`,
                                    location: address,
                                }}
                                assistance={{ phones, emails: readSessionList('sessionExhibitionEmail') }}
                            />
                        )
                    })()}
                </div>


                <div className="app-header header sticky app-heder-with-logo pt-0 visitor-header-light">
                    <div className="container-fluid main-container px-2 px-md-3">
                        <div className="d-flex align-items-center justify-content-between delegate-header-row">
                            {/* LOGO */}
                            <div className="side-header top-logo-almnt d-flex align-items-center justify-content-center" style={{ padding: '0', margin: '0' }}>
                                <img
                                    src={sessionStorage.getItem("ExhibitionLogoSS")}
                                    alt="logo"
                                    className="delegate-header-logo-img"
                                />
                            </div>

                            {/* EXHIBITION INFO: plain text - hidden; below 1200px the ☰ panel shows these
                                details, and desktop uses the icon-tile block below */}
                            <h5 className="exbheader text-white d-none">
                                {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
                                {sessionStorage.getItem("ExhibitionToDateSS")} <br />
                                {sessionStorage.getItem("ExhibitionAddressSS")}
                            </h5>

                            {/* EXHIBITION INFO: desktop, same icon-tile layout as the visitor header */}
                            {(() => {
                                const address = sessionStorage.getItem("ExhibitionAddressSS") || ''
                                const comma = address.indexOf(',')
                                let mobiles = [], emails = []
                                try { mobiles = JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo')) || [] } catch (e) { }
                                try { emails = JSON.parse(sessionStorage.getItem('sessionExhibitionEmail')) || [] } catch (e) { }
                                return (
                                    // This header has no top padding (pt-0), so start 8px down instead of the shared -6px nudge
                                    <div className="vh-info d-none d-xl-flex me-auto" style={{ justifyContent: 'flex-start', paddingLeft: 12, marginTop: 8 }}>
                                        <div className="vh-block" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                                            <div className="vh-row" style={{ justifyContent: 'flex-start', width: '100%' }}>
                                                <span className="vh-icon"><i className="fa fa-calendar"></i></span>
                                                <strong className="vh-date">{sessionStorage.getItem("ExhibitionFromDateSS")} - {sessionStorage.getItem("ExhibitionToDateSS")}</strong>
                                            </div>
                                            <div className="vh-row" style={{ justifyContent: 'flex-start', width: '100%' }}>
                                                <span className="vh-icon"><i className="fa fa-map-marker"></i></span>
                                                <span className="vh-address">
                                                    {comma > -1 ? <><strong>{address.slice(0, comma + 1)}</strong>{address.slice(comma + 1)}</> : address}
                                                </span>
                                            </div>
                                        </div>
                                        {(mobiles.length > 0 || emails.length > 0) && <>
                                            <span className="vh-divider"></span>
                                            <div className="vh-block" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                                                <div className="vh-row">
                                                    <span className="vh-icon vh-icon-round"><i className="fa fa-headphones"></i></span>
                                                    <div>
                                                        <div className="vh-label">For Assistance</div>
                                                        <div className="vh-contact">
                                                            {mobiles.length > 0 && <strong className="vh-phone">{mobiles.join(', ')}</strong>}
                                                            {emails.length > 0 && (
                                                                <span className="vh-email">
                                                                    <i className="fa fa-envelope-o"></i>
                                                                    {emails.map((data, i) => (
                                                                        <a key={i} href={`mailto:${data}`}>{data}{i != emails.length - 1 ? ' / ' : ''}</a>
                                                                    ))}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                    </div>
                                )
                            })()}

                            {/* NOTIFICATION BELL + PROFILE ICON (ms-auto: always at the right edge,
                                also below 1200px where the date / assistance block is hidden) */}
                            <div className="d-flex align-items-center gap-2 pe-1 ms-auto">
                                {/* Corporate Site Button */}
                                <a
                                    href={corporateLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-light rounded-pill d-none d-md-block"
                                    style={{ fontWeight: '500', padding: '5px 15px' }}
                                >
                                    Corporate Site
                                </a>

                                {/* <div className="notification-bell-wrapper" ref={notificationRef} style={{ marginTop: '4px' }}>
                                <i
                                    className="fa fa-bell fa-lg text-white"
                                    onClick={() => { setShowNotifications(!showNotifications); setShowProfile(false); }}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                                {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                                {showNotifications && (
                                    <div className="notification-dropdown shadow">
                                        <div className="notification-dropdown-header">
                                            <span>Notifications</span>
                                            {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                                        </div>
                                        {notifications.length === 0 ? (
                                            <div className="notification-empty"><i className="fa fa-bell-slash-o"></i><br />No notifications</div>
                                        ) : notifications.slice(0, 3).map(n => (
                                            <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                                                <span className={`notification-item-icon ${n.type}`}>
                                                    {n.initial}
                                                </span>
                                                <div className="notification-item-content">
                                                    <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                                                    <NotificationMeta notification={n} />
                                                    {n.time && <div className="notification-item-time">{n.time}</div>}
                                                </div>
                                                <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                                            </div>
                                        ))}
                                        <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                                    </div>
                                )}
                            </div> */}

                                {/* Opens the exhibition details panel (desktop shows these in the header) */}
                                <button
                                    type="button"
                                    className="btn btn-outline-light d-xl-none d-inline-flex align-items-center justify-content-center"
                                    // order: shown after the profile icon (rightmost)
                                    style={{ width: 38, height: 34, padding: 0, borderRadius: 6, order: 99 }}
                                    onClick={toggleMobileMenu}
                                    aria-label="Exhibition details"
                                >
                                    <i className="fa fa-bars"></i>
                                </button>

                                {/* PROFILE ICON */}
                                <div className="position-relative" ref={profileRef}>
                                    <i
                                        className="fa fa-user-circle fa-2x text-white "
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowProfile(!showProfile)}
                                    ></i>

                                    {/* PROFILE DROPDOWN */}
                                    {showProfile && (
                                        <div className="profile-dropdown profile-menu">
                                            <div className="profile-menu-head">
                                                <span className="profile-menu-avatar">
                                                    {(sessionStorage.getItem("firstNameSS") || "?").trim().charAt(0).toUpperCase()}
                                                </span>
                                                <span className="profile-menu-name">{sessionStorage.getItem("firstNameSS")}</span>
                                            </div>

                                            <div className="profile-menu-section">
                                                <div className="profile-menu-title">Quick Links</div>
                                                <a
                                                    href={corporateLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="profile-menu-item"
                                                    onClick={() => { closeMobileMenu(); setShowProfile(false); }}
                                                >
                                                    <i className="fa fa-globe"></i>
                                                    <span>Corporate Site</span>
                                                    <i className="fa fa-external-link profile-menu-trail"></i>
                                                </a>
                                                <a
                                                    href={visitorRegistrationLinkHeader}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="profile-menu-item"
                                                    onClick={() => setShowProfile(false)}
                                                >
                                                    <i className="fa fa-share-alt"></i>
                                                    <span>Share Link</span>
                                                    <i className="fa fa-external-link profile-menu-trail"></i>
                                                </a>
                                            </div>

                                            <div className="profile-menu-section profile-menu-divider">
                                                <Link
                                                    to="/Change_Password"
                                                    className="profile-menu-item"
                                                    onClick={() => setShowProfile(false)}
                                                >
                                                    <i className="fa fa-lock"></i>
                                                    <span>Change Password</span>
                                                </Link>
                                                <button
                                                    type="button"
                                                    className="profile-menu-item profile-menu-logout"
                                                    onClick={onLogoutClick}
                                                >
                                                    <i className="fa fa-sign-out"></i>
                                                    <span>Logout</span>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>{/* end bell+profile group */}
                        </div>

                        {/* Absolute Marquee at the bottom of the header */}
                        <div className="marquee-text" style={{ position: 'absolute', bottom: '-4px', left: '0', width: '100%', pointerEvents: 'none', margin: '0' }}>
                            <marquee
                                behavior="scroll"
                                direction="left"
                                scrollamount="5"
                                ref={marqueeRef}
                                onMouseOver={() => marqueeRef.current?.stop()}
                                onMouseOut={() => marqueeRef.current?.start()}
                                style={{ pointerEvents: 'auto', marginBottom: '0' }}
                            >
                                <b>Disclaimer and Ownership:</b> {disclaimer}
                            </marquee>
                        </div>
                    </div>



                </div>

                {/* /app-Header */}
            </>
            <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
            <NotificationPreviewModal notification={previewItem} onClose={closePreview} />
        </>
    );
}
export default VisitorHeader2;

